/**
 * Catalog entry for one job-import method (Single, Bulk, AgVance, Proagrica, etc.).
 * Pure data — labels and an id. The corresponding import-source icons live in the
 * `SOURCE_ICONS` map (`5-UI/GUI/pages/SubmitJobs/Methods/Bulk/wizard/steps/SourceSelection`)
 * so that the domain layer stays React-free.
 */
export class ImportOption {
	id: number;
	label: string;
	shortLabel: string;
	superUserLabel: string;
	superUserShortLabel: string;

	constructor(id: number, label: string, shortLabel?: string, superUserLabel?: string, superUserShortLabel?: string) {
		this.id = id;
		this.label = label;
		this.shortLabel = shortLabel ?? label;
		this.superUserLabel = superUserLabel ?? label;
		this.superUserShortLabel = superUserShortLabel ?? this.shortLabel;
	}
}

export const ImportOptionChoices = {
	SingleUpload: new ImportOption(1, "Single Upload", "Single", "Single", ""),
	BulkUpload: new ImportOption(2, "Bulk Upload", "Bulk", "Bulk", ""),
	Agvance: new ImportOption(3, "AgVance", "AgVance", "AgVance", "Agv"),
	Proagrica: new ImportOption(4, "Proagrica / AGX", "Proagrica", "Proagrica", "Agx"),
	Agrian: new ImportOption(5, "Import", "Import", "Agn", "Agn"),
};
